import { computed, Directive, input } from '@angular/core';
import { cn } from '@shared/helpers/cn';

export type IconButtonColor = 'white' | 'purple' | 'danger' | 'gray' | 'green';

@Directive({
  selector: '[appIconButton]',
  standalone: true,
  host: { '[class]': 'styles()' },
})
export class AppIconButtonDirective {
  #base =
    '!rounded-lg transition-colors bg-transparent flex items-center justify-center cursor-pointer w-fit p-2';

  class = input<string>();
  color = input<IconButtonColor>('white');
  variant = input<'ghost' | 'solid'>('ghost');

  public styles = computed(() => {
    return cn(
      this.#base,
      {
        // Ghost Variant Styles
        // Purple - Default
        'text-purple-600 hover:!bg-purple-50':
          this.color() === 'purple' && this.variant() === 'ghost',
        // White
        'text-white hover:!bg-white/20':
          this.color() === 'white' && this.variant() === 'ghost',
        // Danger
        'text-red-600 hover:!bg-red-50':
          this.color() === 'danger' && this.variant() === 'ghost',
        // Gray
        'text-gray-600 hover:!bg-slate-200':
          this.color() === 'gray' && this.variant() === 'ghost',
        // Green
        'text-green-600 hover:!bg-green-50':
          this.color() === 'green' && this.variant() === 'ghost',
        'disabled:!text-gray-400 disabled:cursor-not-allowed disabled:pointer-events-none':
          this.variant() === 'ghost',

        // Solid Variant Styles
        // Purple - Default
        'bg-purple-600 text-white hover:bg-purple-800 text-white hover:!scale-105':
          this.variant() === 'solid' && this.color() === 'purple',

        // White
        'bg-white text-gray-800 hover:bg-gray-100':
          this.variant() === 'solid' && this.color() === 'white',
        // Danger
        'bg-red-600 text-white hover:bg-red-700 text-white':
          this.variant() === 'solid' && this.color() === 'danger',
        // Green
        'bg-green-600 text-white hover:bg-green-700 text-white':
          this.variant() === 'solid' && this.color() === 'green',
      },
      this.class(),
    );
  });
}
